var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", {
    attrs: { title: "Change Password" },
    scopedSlots: _vm._u([
      {
        key: "button",
        fn: function() {
          return [
            _c("Button", {
              attrs: { variant: "primary", label: "Update Password" },
              on: { clicked: _vm.changePassword }
            })
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("form-item", {
              attrs: { label: "New Password" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "relative" },
                        [
                          _c("Input", {
                            attrs: {
                              type: _vm.showPassword ? "text" : "password",
                              placeholder: "New Password",
                              error:
                                _vm.$v.input.new_password.$dirty &&
                                !_vm.$v.input.new_password.required
                            },
                            model: {
                              value: _vm.input.new_password,
                              callback: function($$v) {
                                _vm.$set(_vm.input, "new_password", $$v)
                              },
                              expression: "input.new_password"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "absolute top-0 right-0 mr-2 mt-3 ",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = !_vm.showPassword
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.showPassword
                                  ? "fa-eye-slash"
                                  : "fa-eye"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.input.new_password.$dirty &&
                          !_vm.$v.input.new_password.required
                            ? _c("text-error", {
                                attrs: { text: "New Password is required" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Confirm New Password" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "relative" },
                        [
                          _c("Input", {
                            attrs: {
                              type: _vm.showConfirmPassword
                                ? "text"
                                : "password",
                              placeholder: "Confirm New Password",
                              error:
                                _vm.$v.input.confirm_new_password.$dirty &&
                                !_vm.$v.input.confirm_new_password
                                  .sameAsPassword
                            },
                            model: {
                              value: _vm.input.confirm_new_password,
                              callback: function($$v) {
                                _vm.$set(_vm.input, "confirm_new_password", $$v)
                              },
                              expression: "input.confirm_new_password"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "absolute top-0 right-0 mr-2 mt-3 ",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.showConfirmPassword = !_vm.showConfirmPassword
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.showConfirmPassword
                                  ? "fa-eye-slash"
                                  : "fa-eye"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.input.confirm_new_password.$dirty &&
                          !_vm.$v.input.confirm_new_password.sameAsPassword
                            ? _c("text-error", {
                                attrs: {
                                  text: "Confirm New Password not match"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45d36ce0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d36ce0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChangePasswordUser.vue
// module id = null
// module chunks = 